// extracted by mini-css-extract-plugin
module.exports = {"title_hospital":"styles_title_hospital__1QANo","sub_title":"styles_sub_title__3lEH6","nameParner":"styles_nameParner__DJOg2","addressParner":"styles_addressParner__6DNNs"};